import * as THREE from 'three';

const NODE_CORE_RADIUS = 0.155;

export const fwd = new THREE.Vector3();
export const right = new THREE.Vector3();
export const camUp = new THREE.Vector3();
export const titleWorld = new THREE.Vector3();

export function diskR(mesh) {
  const layout = mesh.userData.layoutScale;
  if (layout > 0) return NODE_CORE_RADIUS * layout;
  const size = mesh.userData.nodeMeta?.size ?? 1;
  return NODE_CORE_RADIUS * Math.max(mesh.scale.x, size);
}

export function nestDepthOf(mesh) {
  return mesh?.userData.nodeMeta?.nestDepth ?? 0;
}

export function camPlaneToWorldXY(ex, ey) {
  const rx = right.x;
  const ry = right.y;
  const ux = camUp.x;
  const uy = camUp.y;
  const det = rx * uy - ry * ux;
  if (Math.abs(det) > 0.05) {
    return { x: (ex * uy - ey * ry) / det, y: (rx * ey - ux * ex) / det };
  }
  const rLen = Math.hypot(rx, ry);
  const uLen = Math.hypot(ux, uy);
  if (uLen >= rLen && uLen > 0.05) {
    const t = (ex * ux + ey * uy) / (uLen * uLen);
    return { x: ux * t, y: uy * t };
  }
  if (rLen > 0.05) {
    const t = (ex * rx + ey * ry) / (rLen * rLen);
    return { x: rx * t, y: ry * t };
  }
  return { x: 0, y: 0 };
}

export function alongWorldXY(dx, dy, extraAtNode) {
  let dl = Math.hypot(dx, dy);
  if (dl < 1e-4) {
    dx = right.x;
    dy = right.y;
    dl = Math.hypot(dx, dy) || 1;
  }
  const px = (dx / dl) * right.x + (dy / dl) * right.y;
  const py = (dx / dl) * camUp.x + (dy / dl) * camUp.y;
  const gain = Math.hypot(px, py) || 1;
  const mag = extraAtNode / gain;
  return { x: (dx / dl) * mag, y: (dy / dl) * mag };
}

export function setCameraBasis(camera) {
  camera.getWorldDirection(fwd);
  right.crossVectors(fwd, camera.up);
  if (right.lengthSq() < 1e-8) return false;
  right.normalize();
  camUp.crossVectors(right, fwd).normalize();
  return true;
}

export function viewAlong(pos, camera) {
  return (pos.x - camera.position.x) * fwd.x
    + (pos.y - camera.position.y) * fwd.y
    + (pos.z - camera.position.z) * fwd.z;
}

export function worldToCam(pos, camera) {
  const cx = camera.position.x;
  const cy = camera.position.y;
  const cz = camera.position.z;
  return {
    x: (pos.x - cx) * right.x + (pos.y - cy) * right.y + (pos.z - cz) * right.z,
    y: (pos.x - cx) * camUp.x + (pos.y - cy) * camUp.y + (pos.z - cz) * camUp.z,
    z: (pos.x - cx) * fwd.x + (pos.y - cy) * fwd.y + (pos.z - cz) * fwd.z,
  };
}
